import React from 'react'

const ImageThumbIcon = ({color = 'currentColor', width = 32, height = 32, ...rest}) => (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" fill="#F8F9FA" stroke="#B0B7BF" />
        <path
            d="M12.0007 12.8012C12.0007 13.6848 11.2844 14.4011 10.4008 14.4011C9.51709 14.4011 8.80078 13.6848 8.80078 12.8012C8.80078 11.9175 9.51709 11.2012 10.4008 11.2012C11.2844 11.2012 12.0007 11.9175 12.0007 12.8012Z"
            fill={color}
        />
        <path
            d="M23.2004 8.80078H8.80039C7.4772 8.80078 6.40039 9.87759 6.40039 11.2008V20.8008C6.40039 20.8456 6.41152 20.8879 6.41401 20.9328C6.40273 21.0287 6.40757 21.1255 6.44272 21.2168C6.64033 22.3417 7.61958 23.2008 8.80039 23.2008H23.2004C24.5236 23.2008 25.6004 22.124 25.6004 20.8008V11.2008C25.6004 9.87759 24.5236 8.80078 23.2004 8.80078ZM8.80039 10.4008H23.2004C23.6412 10.4008 24.0003 10.76 24.0003 11.2008V17.5521L19.7924 13.344C19.2452 12.7967 18.3548 12.7967 17.8084 13.344L14.0004 17.152L12.9923 16.144C12.4452 15.5968 11.5547 15.5968 11.0083 16.144L8.00044 19.152V11.2008C8.00044 10.76 8.35962 10.4008 8.80039 10.4008Z"
            fill={color}
        />
    </svg>
)

export default ImageThumbIcon
